export default __webpack_public_path__ + "static/media/register.7a3105e9.png";